import { useState } from "react"
import { CellContext } from "@tanstack/react-table"

import { ApiTypes, UITypes } from "types"

import { ActiveAlertRulesModal } from "./ActiveAlertRulesModal"
import { alertRuleCatalogById } from "./alertRulesCatalog"

import styles from "./index.module.scss"

interface ActiveAlertRulesCellProps {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

const getAlertRuleName = (rule: NonNullable<ApiTypes.Model.Device["alert_rules"]>[number]) => {
  const catalogEntry = (alertRuleCatalogById as Record<string, { title: string } | undefined>)[rule.alert_rule_id]

  return rule.alert_name || catalogEntry?.title || rule.alert_rule_id.replaceAll("_", " ")
}

export const ActiveAlertRulesCell = ({ cell: { row } }: ActiveAlertRulesCellProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const device = row.original.rowSettings.item as ApiTypes.Model.Device
  const alertRuleNames = (device.alert_rules || []).filter(rule => rule.is_enabled).map(getAlertRuleName)
  const [firstAlertRuleName, ...additionalAlertRuleNames] = alertRuleNames

  if (!firstAlertRuleName) return null

  const handleOpenModal = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    setIsModalOpen(true)
  }

  return (
    <>
      <button className={styles.activeAlertRulesCell} type="button" onClick={handleOpenModal}>
        <span className={styles.activeAlertRulesChip}>{firstAlertRuleName}</span>
        {additionalAlertRuleNames.length > 0 && (
          <span className={styles.activeAlertRulesCount}>+{additionalAlertRuleNames.length}</span>
        )}
      </button>
      {isModalOpen && (
        <ActiveAlertRulesModal device={device} alertRuleNames={alertRuleNames} onClose={() => setIsModalOpen(false)} />
      )}
    </>
  )
}
